'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var Background = _interopDefault(require('../background'));

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('background', {
      staticClass: "help-detail",
      attrs: {
        "color": "#fff"
      }
    }, [_vm.data ? _c('div', [_c('div', {
      staticClass: "help-detail-title",
      domProps: {
        "innerHTML": _vm._s(_vm.data.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "help-detail-divide"
    }), _vm._v(" "), _vm._l(_vm.data.list, function (item) {
      return _c('div', {
        key: item,
        staticClass: "help-detail-section",
        domProps: {
          "innerHTML": _vm._s(item)
        }
      });
    })], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
  },
  staticRenderFns: [],
  name: 'help-detail',
  props: {
    data: Object
  },
  components: {
    Background: Background
  }
});

exports.default = index;
